import { MealType } from '@akin-home/amplify';
import { Recipe } from '../types';

export const recipe_filters = {
  /** Only returns recipes for the given meal types */
  byMealType: (meal_types: MealType[]) => (recipes: Recipe[]) => {
    return recipes.filter((recipe) =>
      recipe.mealTypes.some((meal_type) => meal_types.includes(meal_type))
    );
  },

  /** Only returns recipes that don't include the given allergens */
  withoutAllergen: (allergen_ids?: string[]) => (recipes: Recipe[]) => {
    if (!allergen_ids?.length) return recipes;

    return recipes.filter((recipe) => {
      return !recipe.allergyIDs.some((id) => allergen_ids.includes(id));
    });
  },
};
